export default __webpack_public_path__ + "static/media/CampusComedyClub.68d87800.png";